import * as lib from '~/dependencies';
import { colors, paddings } from '~/layout';

export const Container = lib.styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const SearchContactsList = lib.styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* min-height: 80px; */
  /* max-height: 180px; */
  flex: 1;
  padding-left: ${paddings.alternative}px;
  padding-right: ${paddings.alternative}px;
`;

export const VoiceMessageTab = lib.styled.div`
  position: absolute;
  top: 13px;
  right: 20px;
  cursor: pointer;
  z-index: 999;
`;

export const VoiceButton = lib.styled.div`
  cursor: pointer;
  z-index: 999;

  span {
    font-size: 9px;
    color: ${colors.darkGray05};
  }
`;

export const Badge = lib.styled.span`
  width: 15px;
  padding: 2px;
  position: absolute;
  top: -6px;
  right: -9px;
  border-radius: 50%;
  background: #ea6056;
  font-weight: bold;
  color: white !important;
`;

export const BoxSelector = lib.styled.div`
  display: flex;
  min-width: 211px;
  height: 26px;
  background-color: ${colors.lightGray10};
  border-radius: 15px;
  align-items: center;
  justify-content: space-between;

  span {
    text-transform: none!important;
    font-size: 12px;
    font-family: Nunito;
    color: #000;
    opacity: 0.7;
  }

  .padding {
    padding: 0 7px 0 2px;
  }
`;

export const Title = lib.styled.div`
  display: flex;
  width: 66px;
  height: 26px;
  background-color: ${colors.lightGray11};
  border-radius: 15px;
  text-align: center;
  justify-content: center;
  align-items: center;

  span:lang(es) {
    font-size: 9px;
  }

  span {
    font-size: 10px;
    color: ${colors.black};
    opacity: 0.6;
  }
`;
